<template>
  <div>
    <!-- 头部标题 -->
    <div class="listHead">
      <div>
        <div class="sCircle" />
        <span style="font-size: 16px; font-weight: 700">网页栏目样式</span>
      </div>
      <div />
    </div>
    <!-- 内容 -->
    <div
      v-if="haveWebStyle"
      class="Pagedata"
    >
      <div
        v-for="(items, index) in StyleList"
        :key="index"
        class="data_item"
        @click="detal(items)"
      >
        <div
          class="data_item_head"
          :class="[items.styleId == 1 ? '' : 'row_top2']"
        >
          <span>{{ items.name }}</span>
          <img
            v-show="items.styleId == 1"
            src="../../../../assets/icon/icon_active_label.png"
            alt=""
          >
        </div>
        <div
          class="data_item_body"
        >
          <img
            :src="items.image"
            alt=""
          >
        </div>
        <div class="data_item_bottom">
          <span>
            {{ items.styleName }}
          </span>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <mix-dialog
      ref="addDia"
      :modal="true"
      width="800px"
      :visible.sync="showDia"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>主页栏目样式选择</span>
      </div>
      <div class="formBody">
        <div class="flex_row dialog_row">
          <div class="dialog_row_left">
            <span>栏目名称：</span>
          </div>
          <div>
            <span
              v-if="catalog"
              style="color: #2ed095"
            >{{ catalog.name }}</span>
          </div>
        </div>

        <div class="flex_row">
          <div class="dialog_row_left">
            <span>栏目样式：</span>
          </div>

          <div
            v-for="(ite, ind) in siteStyleSLists"
            :key="ind"
            class="data_item"
            :class="[ite.defaultStatus == 0 ? 'row_top' : '',ite.active === 1 ? 'activeBoder':'']"
            @click="checkStyle(ite, ind)"
          >
            <div>
              <div
                v-show="ite.name == '样式一'"
                class="data_item_head2"
              >
                <img
                  src="../../../../assets/icon/icon_active_label.png"
                  alt=""
                >
              </div>
              <div
                class="data_item_body"
              >
                <img
                  :src="ite.image"
                  alt=""
                >
              </div>
              <div class="data_item_bottom">
                <span> {{ ite.name }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="add-match">
        <transition name="el-zoom-in-bottom">
          <div class="">
            <el-button
              class="plainBtn"
              size="medium"
              @click="showDia = false"
            >
              取消
            </el-button>
            <el-button
              size="medium"
              type="primary"
              @click="checkStyleApi"
            >
              确认
            </el-button>
          </div>
        </transition>
      </div>
    </mix-dialog>

    <!-- 头部标题 -->
    <div class="listHead">
      <div>
        <div class="sCircle" />
        <span style="font-size: 16px; font-weight: 700">网页插件</span>
      </div>
    </div>
    <div class="Pagedata">
      <el-table
        v-if="tableData.length > 0 && havePlug"
        :data="tableData"
        border
        :header-cell-style="headCss"
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          width="80"
        />
        <el-table-column
          label="图标"
          align="center"
          width="150"
        >
          <template slot-scope="{ row }">
            <img :src="row.logo">
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="插件名称"
          align="center"
          width="120"
        />

        <el-table-column
          prop="remark"
          label="插件说明"
          align="center"
        />

        <el-table-column
          label="使用页面"
          align="center"
          width="250"
        >
          <template slot-scope="{ row }">
            <el-checkbox-group
              v-model="row.useType"
              @change="checkPlug(row)"
            >
              <el-checkbox label="0">
                主页&栏目页
              </el-checkbox>
              <el-checkbox label="1">
                内容页
              </el-checkbox>
            </el-checkbox-group>
          </template>
        </el-table-column>
      </el-table>
      <div
        v-else
        style="width: 100%; text-align: center; color: #aaa"
      >
        <img src="../../../../assets/image/no_data.png">
      </div>
    </div>
  </div>
</template>
<script>
import api from './proxy';
export default {
    data () {
        return {
            pagination: {
                total: 0,
                current: 1,
                size: 10,
            },
            checkList: [],
            headCss: { 'background-color': '#F1FFFA' }, // 表头样式
            tableData: [],
            showDia: false,
            StyleList: [],
            siteStyleSLists: [],
            catalog: null,
            siteMsg: {},
            haveWebStyle: false,
            havePlug: false,
        };
    },
    created () {
        this.siteMsg = JSON.parse(sessionStorage.getItem('websiteMsg'));
        if (this.siteMsg && this.siteMsg.h5Template) {
            this.getModuleList();
            this.getPageManagePlugList();
            this.catalogStyleList();
        }
    },
    methods: {
        preview () {
            this.$router.push({ name: 'mobileModules' });
        },
        // 获取插件列表
        getPageManagePlugList () {
            const params = {
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.getPageManagePlugList(params).then((res) => {
                if (res.errcode === 0) {
                    this.pagination.total = res.data.totalCount;
                    let tableData = res.data.list;
                    tableData.forEach((e) => {
                        e.useType = e.useType.split(',');
                    });
                    this.tableData = tableData;
                }
            });
        },
        getModuleList () {
            api.getModuleList({ templateId: this.siteMsg.h5TemplateId }).then((res) => {
                if (res.errcode === 0) {
                    console.log(res.data);
                    let ModuleList = res.data;
                    ModuleList.forEach((e) => {
                        if (e.moduleName === '网页栏目样式') {
                            this.haveWebStyle = true;
                        }
                        if (e.moduleName === '网页插件') {
                            this.havePlug = true;
                        }
                    });
                }
            });
        },
        detal (e) {
            this.showDia = true;
            this.catalog = e;
            this.StyleLists();
        },
        catalogStyleList () {
            const params = {
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.catalogStyleList(params).then((res) => {
                if (res.errcode === 0) {
                    this.StyleList = res.data.list;
                }
            });
        },
        StyleLists () {
            const params = {
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.siteStyleSLists(params).then((res) => {
                if (res.errcode === 0) {
                    let siteStyleSLists = res.data.list;
                    console.log('siteStyleSLists: ', siteStyleSLists);
                    // catalog.styleId

                    siteStyleSLists.forEach(e => {
                        e.active = (e.id === this.catalog.styleId ? 1 : 0);
                    });
                    this.siteStyleSLists = siteStyleSLists;
                }
            });
        },
        // 切换默认样式
        checkStyle (item, index) {
            console.log(this.siteStyleSLists);
            this.siteStyleSLists.forEach((e) => {
                e.active = 0;
            });
            this.siteStyleSLists[index].active = 1;
        },
        checkStyleApi () {
            let active = null;
            this.siteStyleSLists.forEach((e) => {
                if (e.active === 1) {
                    active = e;
                }
            });
            const params = {
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
                catalogId: this.catalog.id,
                styleId: active.id,
            };
            api.checkStyle(params).then((res) => {
                if (res.errcode === 0) {
                    this.showDia = false;
                    this.catalogStyleList();
                }
            });
        },
        checkPlug (e) {
            let params = {
                id: e.id,
                useType: e.useType.length > 0 ? e.useType.join(',') : '',
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
            };
            console.log(e.useType.join(','));
            api.checkPlug(params).then(e => {
                // console.log(e);
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.listHead {
  padding-left: 24px;
  padding-right: 24px;
  width: 100%;
  height: 53px;
  line-height: 53px;
  background-color: #fff;
  margin-top: 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sCircle {
  margin-bottom: 2px;
  margin-right: 10px;
  display: inline-block;
  border: 2px solid #ccc;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.Pagedata {
  padding: 16px 23px;
  width: 100%;
  background-color: #fff;
  display: flex;
}
.data_item {
  width: 312px;
  border: 1px solid #eee;
  cursor: pointer;
  margin-right: 20px;
  .data_item_head {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    right: -21px;
    span{
      font-size: 15px;
      font-weight: bold;
      width: 60px;
      line-height: 30px;
      overflow:hidden; //超出的文本隐藏
      text-overflow:ellipsis; //溢出用省略号显示
      white-space:nowrap; //溢出不换行
    }
    img {
      position: relative;
      right: -80px;
      width: 51px;
      height: 51px;
    }
  }
  .data_item_head2 {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    right: -130px;
    img {
      width: 51px;
      height: 51px;
    }
  }
  .data_item_body {
    // width: 100%;
    height: 94px;
    margin: 0 16px;
    // border: 1px solid #eee;
    img {
      width: 100%;
      height: 100%;
    }

  }

  .data_item_bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px 0;

    span {
      font-size: 14px;
      font-weight: 400;

    }
  }
}
.add-match {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.flex_row {
  display: flex;
}
.warp {
  flex-wrap: wrap;
}
.row_top {
  padding: 51px 0 0 0;
}
.row_top2{
  padding-top: 20px;
  bottom: 10px;
  right: 3px !important;
  span{
    line-height: 20px;
  }
}
.dialog_row {
  margin-bottom: 16px;
}

.dialog_row_left {
  margin-right: 24px;
}
.activeBoder{
      background: #F2FCF9;
      // background: chartreuse;
    }
</style>
